module.exports = __webpack_public_path__ + "img/DE00253.e854fbf9.svg";